"use strict";
/* tslint:disable:no-empty */
function noop() { }
exports.noop = noop;
//# sourceMappingURL=noop.js.map


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/rxjs/util/noop.js
// module id = ../../../../rxjs/util/noop.js
// module chunks = 4